export enum TaskIdentifier {
  Single = 'single',
  Workflow = 'workflow',
  Project = 'project',
  SharedAndSingle = 'shared_and_single',
}
